import React, { useEffect, useState, useContext } from "react";
import { FaEye, FaPlus, FaTrash, FaPrint, FaEnvelope, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import { createEnquiry, createfollow, deleteEnq, getAllStudents, getfollowup, sendAdmissionLink, updateEnq } from "../../api/Api";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from "../../Assets/kalam_kids_best_kindergarten_logo.png";
import Pagination from "../../Loader/Pagination"; // Ensure you have a Pagination component
import { Search } from "lucide-react";
import { MdCheckCircle } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { AuthContext } from "../../utils/AuthContext";
import { generateAcademicYears } from "../../utils/academicYearUtils";

const Enquiry = () => {
  const { academicYear, setAcademicYear, selectedBranchId } = useContext(AuthContext);
  const [dataEnq, setDataEnq] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDelete, setShowDelete] = useState(false);
  const [enquiryToDelete, setEnquiryToDelete] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpenAdd, setModalOpenAdd] = useState(false);
  const [isModalOpenEdit, setModalOpenEdit] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [showThankYou, setShowThankYou] = useState(false);
  const [formData, setFormData] = useState({
    studentName: "",
    gender: "",
    dob: "",
    fatherName: "",
    fatherMobile: "",
    fatherEmail: "",
    motherName: "",
    motherMobile: "",
    motherEmail: "",
    area: "",
    city: "",
    state: "",
    age: "",
    plotNo: "",
    street: "",
    landmark: "",
    branch: selectedBranchId || "",
    academicYear: academicYear || "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page
  const [searchQuery, setSearchQuery] = useState(''); // State for search query
  const [followUpDate, setFollowUpDate] = useState('');
  const [followUpRemarks, setFollowUpRemarks] = useState('');
  const [isFollowUpModalOpen, setFollowUpModalOpen] = useState(false);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role");
  const [followUps, setFollowUps] = useState({}); // State to store follow-ups for each enquiry
  const [showFollowUpsModal, setShowFollowUpsModal] = useState(false);
  const [selectedFollowUps, setSelectedFollowUps] = useState([]);
  const [showSendAdmissionDialog, setShowSendAdmissionDialog] = useState(false);
  const [enquiryIdToSend, setEnquiryIdToSend] = useState(null);
  const options = ["Day Care", "Play Group", "Pre KG", "LKG", "UKG"];
  const academicYears = generateAcademicYears();

  // Print functionality
  const triggerPrint = (item) => {
    // Open the print page in a new tab
    const url = `/print-enquiry/${item._id}`;
    window.open(url, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    setIsSubmitting(true);
    if (!formData.branch) {
      alert("Please select branch.");
      setIsSubmitting(false);
      return;
    }

    if (!formData.studentName || !formData.fatherName) {
      alert("Please fill in all required fields.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await createEnquiry(formData);
      console.log("Response from server:", response);
      if (response.success) {
        toast.success("Enquiry added successfully!");
        fetchData(); // Refresh the list
        setModalOpenAdd(false);
        // Reset form
        setFormData({
          studentName: "",
          gender: "",
          dob: "",
          fatherName: "",
          fatherMobile: "",
          fatherEmail: "",
          motherName: "",
          motherMobile: "",
          motherEmail: "",
          area: "",
          city: "",
          state: "",
          age: "",
          plotNo: "",
          street: "",
          landmark: "",
          branch: selectedBranchId || "",
          academicYear: academicYear || "",
        });
      } else {
        toast.error(response.message || "Failed to add enquiry.");
      }
      setIsSubmitting(false);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the form. Please try again.");
      setIsSubmitting(false);
    }
  };

  const handleSendAdmissionLink = async (enquiryId) => {
    const frontendBaseUrl = window.location.origin; // Get the current frontend URL
    try {
      const response = await sendAdmissionLink(enquiryId, frontendBaseUrl);
      if (response.success) {
        toast.success("Admission link sent successfully!");
      } else {
        toast.error(response.message || "Failed to send admission link.");
      }
    } catch (error) {
      console.error("Error sending admission link:", error);
      toast.error("Failed to send admission link.");
    }
  };

  const confirmSendAdmissionLink = async () => {
    if (enquiryIdToSend) {
      await handleSendAdmissionLink(enquiryIdToSend);
      setShowSendAdmissionDialog(false);
      setEnquiryIdToSend(null);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "dob" && value) {
      const dob = new Date(value);
      const currentDate = new Date();
      let calculatedAge = currentDate.getFullYear() - dob.getFullYear();
      const monthDiff = currentDate.getMonth() - dob.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dob.getDate())) {
        calculatedAge--;
      }
      setFormData((prevData) => ({
        ...prevData,
        age: calculatedAge,
      }));
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getAllStudents();
      if (response.data?.length) {
        setDataEnq(response.data.reverse());

        // Fetch follow-ups for each enquiry
        const followUpPromises = response.data.map(async (item) => {
          const followUpResponse = await getfollowup(item._id);
          return followUpResponse.success ? followUpResponse.data : [];
        });

        const followUpResponses = await Promise.all(followUpPromises);
        const allFollowUps = followUpResponses.flat();
        setFollowUps(allFollowUps);
      } else {
        setDataEnq([]);
        console.log("No admissions found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [academicYear, searchQuery, startDate, endDate]); 









  const handleView = (item) => {
    setSelectedEnquiry(item);
    setModalOpen(true);
  };

  const handleDeleteEnq = async (id) => {
    if (!id) {
      console.warn("No ID passed to delete handler");
      return;
    }
    console.log("Deleting enquiry with id:", id);
    try {
      await deleteEnq(id);
      setDataEnq(prev => prev.filter(item => item._id !== id));
      setShowDelete(false);
      setEnquiryToDelete(null);
      toast.success('Enquiry deleted successfully');
    } catch (error) {
      console.error("Failed to delete enquiry:", error);
      toast.error('Failed to delete enquiry');
    }
  };
  const filteredData = dataEnq.filter(item => {
    const searchLower = searchQuery.toLowerCase();
    const applicationDate = new Date(item.createdAt); // Assuming dob is the application date
    const start = new Date(startDate);
    const end = new Date(endDate);

    const isWithinDateRange = (!startDate || applicationDate >= start) && (!endDate || applicationDate <= end);

    return (
      isWithinDateRange &&
      (item.studentName.toLowerCase().includes(searchLower) ||
        item.fatherName.toLowerCase().includes(searchLower) ||
        item.fatherMobile.includes(searchQuery)
      )
    );
  });

const handleEdit = (item) => {
  console.log("Selected Item:", item);
  console.log("Selected ID:", item._id);

  setSelectedEnquiry(item);

  setFormData({
    studentName: item.studentName,
    gender: item.gender,
    dob: item.dob ? item.dob.slice(0, 10) : "",
    fatherName: item.fatherName,
    fatherMobile: item.fatherMobile,
    fatherEmail: item.fatherEmail || "",
    motherName: item.motherName || "",
    motherMobile: item.motherMobile || "",
    motherEmail: item.motherEmail || "",
    area: item.area || "",
    city: item.city || "",
    state: item.state || "",
    age: item.age || "",
    plotNo: item.plotNo || "",
    street: item.street || "",
    landmark: item.landmark || "",
    branch: item.branch || selectedBranchId || "",
    academicYear: item.academicYear || academicYear || "",
    admissionFor: item.admissionFor || "",
  });

  setModalOpenEdit(true);
};

const handleEditSubmit = async (e) => {
  e.preventDefault();
  if (!selectedEnquiry?._id) {
    console.error("No enquiry selected for edit.");
    toast.error("No enquiry selected for update.");
    return;
  }
  console.log("Updating enquiry id:", selectedEnquiry._id, formData);
  setIsSubmitting(true);
  try {
    const payload = {
      ...formData,
      branch: selectedBranchId || formData.branch,
      academicYear: academicYear || formData.academicYear,
    };
    const response = await updateEnq(selectedEnquiry._id, payload);
    if (response.success) {
      toast.success("Enquiry updated successfully!");
      fetchData();
      setModalOpenEdit(false);
    } else {
      toast.error(response.message || "Failed to update enquiry.");
    }
  } catch (error) {
    console.error("Error updating enquiry:", error);
    toast.error(error.message || "Failed to update enquiry.");
  } finally {
    setIsSubmitting(false);
  }
};
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const currentData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const handleFollowUpSubmit = async (e) => {
    e.preventDefault();
    console.log("Follow-Up Date:", followUpDate);
    console.log("Follow-Up Remarks:", followUpRemarks);
    if (!followUpDate || !followUpRemarks) {
      alert("Please fill in all required fields for the follow-up.");
      return;
    }
    try {
      const followUpData = {
        enquiryId: selectedEnquiry._id, // Use the selected enquiry ID
        followUpDate,
        remarks: followUpRemarks,
        academicYear,
      };
      const followUpResponse = await createfollow(followUpData);
      console.log("Follow-Up Response:", followUpResponse);
      toast.success('Follow-Up added successfully');
      // Reset the form
      setFollowUpDate('');
      setFollowUpRemarks('');
      setFollowUpModalOpen(false);
    } catch (error) {
      console.error("Failed :", error);
      toast.error('Failed to submit');
    }
  };
  const handleTrackFollowUps = (enquiryId) => {
    const selectedFollowUps = followUps.filter(followUp => followUp.enquiryId === enquiryId);
    setSelectedFollowUps(selectedFollowUps); // Store the selected follow-ups in state
    setShowFollowUpsModal(true); // Open the modal
  };

  return (
    <div className="p-4 max-w-screen-xl mx-auto">
      <ToastContainer />
      <div className="flex flex-wrap justify-between items-center mb-6 gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
        <h1 className="text-xl text-[#16bab1] font-extrabold uppercase tracking-tight">Enquiry List</h1>
        
        <div className="flex flex-wrap items-center gap-4">
          {/* Search bar */}
          <div className="relative min-w-[280px]">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search student or father name..."
              className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-[#16bab1]/20 focus:border-[#16bab1] transition-all"
            />
          </div>

          {/* Academic Year Filter */}
          <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Year:</label>
            <select
              value={academicYear}
              onChange={(e) => setAcademicYear(e.target.value)}
              className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
            >
              <option value="">Overall View</option>
              {academicYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          {/* Date range */}
          <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
            <span className="text-xs font-bold text-gray-500 uppercase">From:</span>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="bg-transparent text-sm font-medium outline-none"
            />
            <span className="text-xs font-bold text-gray-500 uppercase ml-2">To:</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="bg-transparent text-sm font-medium outline-none"
            />
          </div>

          <button 
            onClick={() => setModalOpenAdd(true)} 
            className="flex items-center gap-2 px-5 py-2.5 bg-[#16bab1] hover:bg-[#129a93] text-white font-bold rounded-lg shadow-md hover:shadow-lg transition-all"
          >
            <FaPlus size={14} />
            <span>Add Enquiry</span>
          </button>
        </div>
      </div>



      {loading ? (
        <div className="flex justify-center"><Loader /></div>
      ) : currentData.length === 0 ? (
        <div className="text-[#16bab1] text-center mt-8">
          No admissions right now.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-200 text-sm sm:text-base">
            <thead className="bg-[#16bab1] text-white">
              <tr>
                {["EQ.No", "Name", "Father Name", "Father Mobile", "Enquiry For", "Year", "Enquiry Date", "Followup", "remark", "View", "Print"]
                  .map((th, i) => (
                    <th key={i} className="border border-gray-300 px-4 py-2">
                      {th}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, idx) => (
                <tr key={item._id} className="hover:bg-gray-100">
                 <td className="border px-4 py-2 text-[#16bab1]">

  Eq.No {filteredData.length - ((currentPage - 1) * itemsPerPage + idx)}

</td>
                  <td className="border px-4 py-2">{item.studentName}</td>
                  <td className="border px-4 py-2">{item.fatherName}</td>
                  <td className="border px-4 py-2">{item.fatherMobile}</td>
                  <td className="border px-4 py-2">{item.admissionFor || 'N/A'}</td>
                  <td className="border px-4 py-2">{item.academicYear || 'N/A'}</td>
                  <td className="border px-4 py-2">
                    {item.createdAt ? item.createdAt.slice(0, 10) : 'N/A'}
                  </td>
                  <td className="border px-4 py-2">
                    {Array.isArray(followUps) && followUps.length > 0 ? (
                      // Get the latest follow-up
                      (() => {
                        const latestFollowUp = followUps
                          .filter(followUp => followUp.enquiryId === item._id)
                          .sort((a, b) => new Date(b.followUpDate) - new Date(a.followUpDate))[0]; // Sort by date descending

                        return (
                          <>
                            {latestFollowUp ? latestFollowUp.followUpDate.slice(0, 10) : 'N/A'}
                            {/* <span>{latestFollowUp.remarks}</span> */}

                          </>
                        );
                      })()
                    ) : (
                      'No Follow-Ups'
                    )}
                  </td>


                  <td className="border px-4 py-2">
                    {Array.isArray(followUps) && followUps.length > 0 ? (
                      // Get the latest follow-up
                      (() => {
                        const latestFollowUp = followUps
                          .filter(followUp => followUp.enquiryId === item._id)
                          .sort((a, b) => new Date(b.followUpDate) - new Date(a.followUpDate))[0]; // Sort by date descending

                        return (
                          <>
                            {/* <strong>{new Date(latestFollowUp.followUpDate).toLocaleDateString()}</strong> */}
                            <span>{latestFollowUp ? latestFollowUp.remarks : 'N/A'}</span>

                          </>
                        );
                      })()
                    ) : (
                      'No Remarks'
                    )}
                  </td>


                  <td className="border space-x-4 px-4 py-2 text-[#16bab1] text-center">
                    <button onClick={() => handleView(item)}>
                      <FaEye className="text-blue-500 hover:text-blue-700" />
                    </button>
                    <button onClick={() => handleEdit(item)}>
                      <FaEdit className="text-yellow-500 hover:text-yellow-700" />
                    </button>
                    {userRole === 'admin' && (
                      <button
                        onClick={() => {
                          setEnquiryToDelete(item._id);
                          setShowDelete(true);
                        }}
                      >
                        <FaTrash className="text-red-500 hover:text-red-700" />
                      </button>
                    )}
                    <button onClick={() => {
                      setSelectedEnquiry(item);
                      setFollowUpModalOpen(true);
                    }}>
                      <FaPlus className="text-green-500 hover:text-green-700" />
                    </button>
                    <button onClick={() => handleTrackFollowUps(item._id)} className="ml-2 text-blue-500">Track</button>
                    <button onClick={() => { setEnquiryIdToSend(item._id); setShowSendAdmissionDialog(true); }} className="ml-2 text-purple-500 hover:text-purple-700">
                      <FaEnvelope />
                    </button>
                  </td>
                  <td className="border px-4 py-2 text-center">
                    <button onClick={() => triggerPrint(item)} className="text-gray-600 hover:text-black">
                      <FaPrint size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>





          </table>
        </div>
      )}

      {showDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg">
            <h2 className="text-lg font-bold mb-2">Confirm Deletion</h2>
            <p>Are you sure you want to delete this enquiry?</p>
            <div className="flex justify-end mt-4">
              <button
                className="bg-gray-300 text-black py-1 px-3 rounded mr-2"
                onClick={() => setShowDelete(false)}
              >
                No
              </button>
              <button
                className="bg-red-500 text-white py-1 px-3 rounded"
                onClick={() => handleDeleteEnq(enquiryToDelete)}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {showFollowUpsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-y-auto">
            <div className="mb-4 border-b pb-2 flex justify-between">
              <h2 className="text-2xl font-semibold text-gray-800">All Follow-Ups</h2>
              <button
                onClick={() => setShowFollowUpsModal(false)}
                className="text-gray-500 hover:text-red-600 text-xl font-bold"
              >
                <IoIosCloseCircleOutline size={24} />
              </button>
            </div>

            {selectedFollowUps.length > 0 ? (
              <div className="space-y-3">
                {selectedFollowUps.map((followUp, index) => (
                  <div
                    key={index}
                    className="p-3 bg-gray-50 rounded-lg shadow-sm hover:bg-gray-100 transition"
                  >
                    <div className="text-sm text-gray-600 font-medium">
                      {new Date(followUp.followUpDate).toLocaleDateString()}
                    </div>
                    <div className="text-gray-800 text-base mt-1">{followUp.remarks}</div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500 text-center">No follow-ups found for this enquiry.</p>
            )}

            <div className="flex justify-end mt-6">

            </div>
          </div>
        </div>
      )}


      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-2xl shadow-2xl w-full max-w-4xl">
            <div className="flex items-center justify-center mb-5 border-b pb-4">
              <div className="flex items-center space-x-4">
                <img src={logo} alt="Kalam Kids Logo" className="h-40 w-40 object-contain" />
                <div className="bg-gray-600 h-10 w-0.5"></div>
                <div>
                  <h1 className="text-[#16bab1] text-xl font-extrabold">
                    KINDERGARTEN ADMISSION ENQUIRY FORM : {selectedEnquiry?.academicYear || academicYear}
                  </h1>
                  <p className="text-gray-700 font-medium text-sm md:text-base mt-1">
                    Smart start. Strong foundation.
                  </p>
                </div>
              </div>
            </div>

            <form className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <input
                type="text"
                name="studentName"
                placeholder="Student Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.studentName || ""}
                readOnly
              />
              <select
                name="gender"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.gender || ""}
                readOnly
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>

              <div className="relative">
                <input
                  type="date"
                  name="dob"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={selectedEnquiry?.dob.slice(0, 10) || ""}
                  readOnly
                />
                {selectedEnquiry?.age !== undefined && selectedEnquiry?.age !== "" && (
                  <div className="absolute top-4 right-12 flex items-center text-gray-700 font-medium">
                    Age: <span className="ml-2">{selectedEnquiry.age}</span>
                  </div>
                )}
              </div>

              <input
                type="text"
                name="fatherName"
                placeholder="Father Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.fatherName || ""}

                readOnly
              />
              <input
                type="text"
                name="fatherMobile"
                placeholder="Father's Mobile Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus ```javascript
                focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.fatherMobile || ""}
                readOnly
              />
              <input
                type="email"
                name="fatherEmail"
                placeholder="Father's Email ID"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.fatherEmail || ""}
                readOnly
              />

              <input
                type="text"
                name="admissionFor"
                placeholder="Enquiry For"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.admissionFor || ""}
                readOnly
              />

              <input
                type="text"
                name="motherName"
                placeholder="Mother Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.motherName || ""}
                readOnly
              />
              <input
                type="text"
                name="motherMobile"
                placeholder="Mother's Mobile Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.motherMobile || ""}
                readOnly
              />
              <input
                type="email"
                name="motherEmail"
                placeholder="Mother's Email ID"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.motherEmail || ""}
                readOnly
              />

              <input
                type="text"
                name="plotNo"
                placeholder="Plot No/Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.plotNo || ""}
                readOnly />
              <input
                type="text"
                name="street"
                placeholder="Street"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.street || ""}
                readOnly
              />
              <input
                type="text"
                name="landmark"
                placeholder="Landmark"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.landmark || ""}
                readOnly
              />

              <input
                type="text"
                name="area"
                placeholder="Area"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.area || ""}
                readOnly
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.city || ""}
                readOnly
              />
              <input
                type="text"
                name="state"
                placeholder="State"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={selectedEnquiry?.state || ""}
                readOnly
              />
            </form>

            <div className="flex justify-end gap-4 mt-8">
              <button
                className="px-6 py-2 border text-black rounded-md"
                onClick={() => setModalOpen(false)}
              >
                Close
              </button>
              <button
                className="px-6 py-2 bg-[#16bab1] text-white rounded-md flex items-center gap-2"
                onClick={() => triggerPrint(selectedEnquiry)}
              >
                <FaPrint /> Print Form
              </button>
            </div>
          </div>
        </div>
      )}
      {isModalOpenAdd && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-2xl shadow-2xl w-full max-w-4xl ">
            <div className="flex items-center  justify-center mb-5 border-b pb-4">
              <div className="flex items-center space-x-4">
                <img src={logo} alt="Kalam Kids Logo" className="h-40 w-40 object-contain" />
                <div className="bg-gray-600 h-10 w-0.5 "></div>

                <div>
                  <div>
                    <h1 className="text-[#16bab1] text-[#16bab1]xl md:text-[#16bab1]xl font-extrabold">
                      ENQUIRY FORM : {academicYear}
                    </h1>
                    <br />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Enquiry For</label>
                    <div className="flex flex-wrap gap-2 mt-1">
                      {options.map((option) => (
                        <div
                          key={option}
                          onClick={() =>
                            setFormData((prev) => ({ ...prev, admissionFor: option }))
                          }
                          className={`cursor-pointer capitalize px-3 py-1 text-xs rounded-full border ${formData.admissionFor === option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                            }`}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <input
                type="text"
                name="studentName"
                placeholder="Student Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <select
                name="gender"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>

              {/* Date of Birth */}
              <div className="relative">
                <input
                  type="date"
                  name="dob"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  onChange={handleInputChange}
                />
                {formData.age !== "" && (
                  <div className="absolute top-4 right-12 flex items-center text-gray-700 font-medium">
                    Age: <span className="ml-2">{formData.age}</span>
                  </div>
                )}
              </div>

              {/* Father Details */}
              <input
                type="text"
                name="fatherName"
                placeholder="Father Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="fatherMobile"
                placeholder="Father's Mobile Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <input
                type="email"
                name="fatherEmail"
                placeholder="Father's Email ID"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />

              {/* Mother Details */}
              <input
                type="text"
                name="motherName"
                placeholder="Mother Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="motherMobile"
                placeholder="Mother's Mobile Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />

              <input
                type="email"
                name="motherEmail"
                placeholder="Mother's Email ID"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />

              {/* New Address Fields */}
              <input
                type="text"
                name="plotNo"
                placeholder="Plot No/Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="street"
                placeholder="Street"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="landmark"
                placeholder="Landmark"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />

              {/* Address */}
              <input
                type="text"
                name="area"
                placeholder="Area"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />

              <input
                type="text"
                name="state"
                placeholder="State"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={handleInputChange}
              />
              <select
                name="academicYear"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.academicYear}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Academic Year</option>
                {academicYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </form>

            {/* Action Buttons */}
            <div className="flex justify-end gap-4 mt-3">
              <button
                className="px-6 py-2 border text-black rounded-md"
                onClick={() => setModalOpenAdd(false)}
              >
                Close
              </button>
              {<button
                type="submit"
                className="px-6 py-2 bg-[#16bab1] text-white rounded-md shadow-lg"
                onClick={handleSubmit}
              >
                {isSubmitting ? <Loader /> : "Submit"}
              </button>}
            </div>
          </div>
        </div>
      )}
      {isModalOpenEdit && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-2xl shadow-2xl w-full max-w-4xl ">
            <div className="flex items-center  justify-center mb-5 border-b pb-4">
              <div className="flex items-center space-x-4">
                <img src={logo} alt="Kalam Kids Logo" className="h-40 w-40 object-contain" />
                <div className="bg-gray-600 h-10 w-0.5 "></div>

                <div>
                  <div>
                    <h1 className="text-[#16bab1] text-lg font-extrabold">
                      EDIT ENQUIRY FORM : {formData.academicYear}
                    </h1>
                    <br />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Enquiry For</label>
                    <div className="flex flex-wrap gap-2 mt-1">
                      {options.map((option) => (
                        <div
                          key={option}
                          onClick={() =>
                            setFormData((prev) => ({ ...prev, admissionFor: option }))
                          }
                          className={`cursor-pointer capitalize px-3 py-1 text-xs rounded-full border ${formData.admissionFor === option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                            }`}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleEditSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <input
                type="text"
                name="studentName"
                placeholder="Student Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.studentName}
                onChange={handleInputChange}
              />
              <select
                name="gender"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.gender}
                onChange={handleInputChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>

              {/* Date of Birth */}
              <div className="relative">
                <input
                  type="date"
                  name="dob"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={formData.dob}
                  onChange={handleInputChange}
                />
                {formData.age !== "" && (
                  <div className="absolute top-4 right-12 flex items-center text-gray-700 font-medium">
                    Age: <span className="ml-2">{formData.age}</span>
                  </div>
                )}
              </div>

              {/* Father Details */}
              <input
                type="text"
                name="fatherName"
                placeholder="Father Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.fatherName}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="fatherMobile"
                placeholder="Father's Mobile Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.fatherMobile}
                onChange={handleInputChange}
              />
              <input
                type="email"
                name="fatherEmail"
                placeholder="Father's Email ID"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.fatherEmail}
                onChange={handleInputChange}
              />

              {/* Mother Details */}
              <input
                type="text"
                name="motherName"
                placeholder="Mother Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.motherName}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="motherMobile"
                placeholder="Mother's Mobile Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.motherMobile}
                onChange={handleInputChange}
              />

              <input
                type="email"
                name="motherEmail"
                placeholder="Mother's Email ID"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.motherEmail}
                onChange={handleInputChange}
              />

              {/* New Address Fields */}
              <input
                type="text"
                name="plotNo"
                placeholder="Plot No/Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.plotNo}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="street"
                placeholder="Street"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.street}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="landmark"
                placeholder="Landmark"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.landmark}
                onChange={handleInputChange}
              />

              {/* Address */}
              <input
                type="text"
                name="area"
                placeholder="Area"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.area}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.city}
                onChange={handleInputChange}
              />

              <input
                type="text"
                name="state"
                placeholder="State"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.state}
                onChange={handleInputChange}
              />
              <select
                name="academicYear"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.academicYear}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Academic Year</option>
                {academicYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </form>

            {/* Action Buttons */}
            <div className="flex justify-end gap-4 mt-3">
              <button
                className="px-6 py-2 border text-black rounded-md"
                onClick={() => setModalOpenEdit(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-[#16bab1] text-white rounded-md shadow-lg"
                onClick={handleEditSubmit}
              >
                {isSubmitting ? <Loader /> : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
      {isFollowUpModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-2xl shadow-2xl w-full max-w-md">
            <h2 className="text-lg font-bold mb-2">Add Follow-Up</h2>
            <form onSubmit={handleFollowUpSubmit} className="flex flex-col">
              <label className="mb-2">Follow-Up Date:</label>
              <input
                type="date"
                value={followUpDate}
                onChange={(e) => setFollowUpDate(e.target.value)}
                className="border border-gray-300 rounded p-2 mb-4"
                required
              />
              <label className="mb-2">Remarks:</label>
              <textarea
                value={followUpRemarks}
                onChange={(e) => setFollowUpRemarks(e.target.value)}
                className="border border-gray-300 rounded p-2 mb-4"
                required
              />
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="px-4 py-2 border text-black rounded-md"
                  onClick={() => window.history.back()}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#16bab1] text-white rounded-md"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showSendAdmissionDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-lg font-bold mb-4">Confirm Sending Admission Link</h2>
            <p className="text-gray-700 mb-6">Are you sure you want to send the admission link to this enquiry?</p>
            <div className="flex justify-end gap-4">
              <button
                className="px-6 py-2 border border-gray-300 text-black rounded-md hover:bg-gray-50"
                onClick={() => {
                  setShowSendAdmissionDialog(false);
                  setEnquiryIdToSend(null);
                }}
              >
                No
              </button>
              <button
                className="px-6 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600"
                onClick={confirmSendAdmissionLink}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {showThankYou && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <MdCheckCircle
              className="text-green-500 mx-auto mb-3" size={48} />
            <p className="text-center font-bold text-gray-800">Enquiry Added Successfully!</p>
          </div>
        </div>
      )}

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};

export default Enquiry;